//德语
export default {
    首页:"Titelseite",
    我的资产:"mein Vermögen",
    重置登录密码:"Login-Passwort zurücksetzen",
    重置登录密码后:"Nach dem Zurücksetzen des Login-Passworts sind Währungsabhebungen und außerbörsliche Überweisungen innerhalb von 24 Stunden verboten.",
    请选择:"bitte auswählen",
    密码在:"Das Passwort ist zwischen 6 und 16 Zeichen lang und besteht aus Zahlen und Buchstaben",
    请确认密码:"Bitte bestätigen Sie Ihr Passwort",
    产品列表:"Produktliste",
    币种:"Währung",
    期限:"der Begriff",
    订单列表:"Bestellliste",
    交易用:"Zum Handeln",
    立即入金开始您的第一笔交易:"Zahlen Sie jetzt Geld ein, um Ihren ersten Handel zu starten",
    立即入金:"Jetzt einzahlen",
    币种对:"Währungspaar",
    涨幅:"Zunahme",
    交易量:"Handelsvolumen",
    欢迎登录:"Bitte einloggen",
    登录:"Anmeldung",
    新用户注册:"Neue Benutzerregistrierung",
    总资产折合:"Gesamtvermögen umgerechnet",
    冻结:"einfrieren",
    折合:"umgewandelt",
    充值币种:"Währung aufladen",
    充值数量:"Auflademenge",
    确认信息:"Informationen bestätigen",
    充币网络:"Einzahlungsnetzwerk",
    欢迎注册:"Willkommen zur Registrierung",
    点击打开:"Klicken Sie zum Öffnen",
    这是一段信息:"Dies ist eine Information",
    提币数量:"Anzahl der abgehobenen Münzen",
    提币:"Münzen abheben",
    百万用户首选:"Die erste Wahl von Millionen von Benutzern",
    小时成交量:"24-Stunden-Handelsvolumen",
    优质数字资产:"Hochwertige digitale Assets",
    我们的核心产品:"Unsere Kernprodukte",
    你可以选择丰富的交易方式:"Sie können aus einer Vielzahl von Handelsmethoden wählen",
    现货:"Spotware",
    我们提供:"wir bieten an",
    币种的交易服务:"Devisenhandelsdienstleistungen",
    合约:"Vertrag",
    使用合约丰富你的交易体验:"Nutzen Sie Verträge, um Ihr Handelserlebnis zu bereichern",
    赚币:"Verdienen Sie Münzen",
    行业内领先收益:"Branchenführender Umsatz",
    多元化的产品服务:"Diversifizierte Produkte und Dienstleistungen",
    选择更多:"Wählen Sie weitere Dienste und erkunden Sie endlose Möglichkeiten",
    福利中心:"Wohlfahrtszentrum",
    完成新手任务:"Erledige Anfängeraufgaben",
    会员:"Mitglied",
    享受全网最多权益:"Genießen Sie die meisten Vorteile im gesamten Netzwerk",
    社区:"Gemeinschaft",
    在这里发现币圈财富机会:"Entdecken Sie hier Wohlstandsmöglichkeiten im Währungskreis",
    随时随地开启交易:"Beginnen Sie jederzeit und überall mit dem Handel",
    全面支持:"Volle Unterstützung",
    和:"Und",
    交割:"Lieferung",
    关于我们:"über uns",
    账变记录:"Kontoänderungsaufzeichnungen",
    股票:"Aktie",
    加密货币:"Kryptowährung",
    加载中:"Wird geladen...",
    已经全部加载完毕:"Alle wurden geladen",
    暂无记录:"Keine Aufzeichnungen",
    高级认证:"Erweiterte Zertifizierung",
    姓名:"Name",
    请输入姓名:"Bitte geben Sie Ihren Namen ein",
    护照编号:"Ausweisnummer",
    请输入护照编号:"Bitte geben Sie die Passnummer ein",
    护照照片:"Ausweisfoto",
    申请认证:"Beantragen Sie die Zertifizierung",
    提示:"Hinweis",
    确定:"Sicher",
    提交失败:"Übermittlung fehlgeschlagen",
    上传失败:"Upload fehlgeschlagen",
    身份认证:"Authentifizierung",
    身份证号:"ID-Nummer",
    请输入身份证号:"Bitte geben Sie die Identifikationsnummer ein",
    身份证照片:"Ausweisfoto",
    申请认证:"Beantragen Sie die Zertifizierung",
    修改资金密码:"Fondspasswort ändern",
    旧密码:"Altes Passwort",
    请输入旧密码:"Bitte geben Sie das alte Passwort ein",
    新密码:"Neues Kennwort",
    请输入6位数字:"Bitte geben Sie 6 Ziffern ein",
    确认新密码:"Bestätigen Sie das neue Passwort",
    请再次输入新密码:"Bitte geben Sie erneut das neue Passwort ein",
    提交:"einreichen",
    请输入新密码:"Bitte geben Sie ein neues Passwort ein",
    请输入6位数新密码:"Bitte geben Sie ein neues 6-stelliges Passwort ein",
    请确认两次密码输入一致:"Bitte bestätigen Sie, dass die beiden eingegebenen Passwörter konsistent sind",
    修改登录密码:"Login-Passwort ändern",
    密码长度:"Passwort (6-12 Zeichen)",
    密码长度提示:"Bitte geben Sie 6–12 Zeichen ein, einschließlich Zahlen oder Buchstaben",
    客服:"Kundendienst",
    永续:"Perpetu",
    交割:"Lieferung",
    永续合约:"Futures",
    交割合约:"Lieferverträge",
    全仓:"Vollposition",
    开多:"Long",
    开空:"Short",
    价格:"Preis",
    开仓金额:"Eröffnungsbetrag",
    可用金额:"Verfügbares Kapital",
    合约金额:"Handelsbetrag",
    保证金:"Margin",
    手续费:"Gebühren",
    看涨:"kaufen",
    看跌:"verkaufen",
    交割时间:"Lieferzeit",
    数量:"Stück",
    持有仓位:"Offene Positionen",
    当前委托:"Aktuelle Aufträge",
    历史订单:"Historische Orden",
    暂无数据:"Keine Daten",
    购买价:"Kaufpreis",
    市价: "Marktorder",
    限价: "Limitorder",
    现价:"Aktueller Preis",
    金额:"Betrag",
    盈亏:"Gewinn-und Verlust",
    操作:"arbeiten",
    平仓:"Geschlossene Position",
    撤单:"Bestellung stornieren",
    方向:"Richtung",
    剩余时间:"übrige Zeit",
    交割时间:"Lieferzeit",
    详情:"Einzelheiten",
    名称:"Name",
    最新价格:"Letzter Preis",
    h24涨跌:"24h Änderung",
    h24涨跌幅:"24h Change",
    请输入开仓金额:"Bitte geben Sie den Eröffnungsbetrag ein",
    请输入开仓价格:"Bitte geben Sie den Eröffnungspreis ein",
    确定执行撤单操作:"Sind Sie sicher, dass Sie die Bestellung stornieren möchten?",
    确定执行平仓操作:"Sind Sie sicher, dass Sie den Positionsschließungsvorgang ausführen?",
    交割合约历史:"Liefervertragshistorie",
    历史仓位:"Historische Positionen",
    到期时间:"Ablaufdatum",
    闪兑:"Flash-Austausch",
    从:"Von",
    最大:"maximal",
    可用数量:"Verfügbare Menge",
    至:"Zu",
    复制成功:"Erfolgreich kopiert",
    基金理财:"Finanzverwaltung des Fonds",
    托管金额:"Treuhandbetrag",
    总收益:"Gesamtumsatz",
    当日收益:"Einkommen des Tages",
    托管订单:"Treuhandauftrag",
    规则:"Regel",
    日收益:"Tägliches Einkommen",
    限额:"Grenze",
    周期:"Zyklus",
    天:"Himmel",
    立即买入:"Kaufe jetzt",
    购买:"Kaufen",
    购买日:"Kaufdatum",
    起息日:"Datum der Wertstellung",
    派息时间:"Zeitpunkt der Dividendenzahlung",
    每日:"täglich",
    计息结束日:"Enddatum der Zinsabgrenzung",
    提前赎回:"vorzeitige Rückzahlung",
    预计收益:"Geschätzter Umsatz",
    今日日收益:"Heute (Tageseinkommen)",
    最少可投:"Minimale Investition",
    最大可投:"Maximale Investition",
    请输入买入金额:"Bitte geben Sie den Kaufbetrag ein",
    可用金额:"Verfügbarer Betrag",
    请输入买入金额:"Bitte geben Sie den Kaufbetrag ein",
    质押金额:"Pfandbetrag",
    累计收益:"Kumuliertes Einkommen",
    开始时间:"Anfangszeit",
    结束时间:"Endzeit",
    理财规则:"Finanzregeln",
    理财规则1:"Die Finanzverwaltung erfolgt durch die Übertragung von USDT an die Plattform, und das professionelle Team der Plattform führt Finanzarbitrage durch. Teilnehmer können während der Fondsverwahrungsperiode einen Anteil an den Finanzverwaltungserträgen der Plattform erhalten.",
    收益计算:"Umsatzberechnung",
    理财规则2:"Ein Mitglied zahlt 10.000U auf der Plattform ein und wählt ein Finanzprodukt mit einem Zyklus von 5 Tagen und einem täglichen Einkommen von 0,3 % ~ 0,5 %. Das tägliche Einkommen ist wie folgt:",
    最低:"am niedrigsten",
    最高:"Höchste",
    理财规则3:"Beides: Sie können es nach 5 Tagen erhalten",
    理财规则4:"Die Erträge werden täglich ausgeschüttet. Die ausgeschütteten Erträge können jederzeit abgerufen, abgehoben und auf das Kapital eingezahlt werden. Nach Fälligkeit werden sie automatisch auf Ihr Konto zurückgebucht.",
    关于违约金:"Über pauschalierten Schadensersatz",
    理财规则5:"Wenn Sie das nicht abgelaufene Kapital übertragen möchten, fällt eine Vertragsstrafe an.",
    理财规则6:"Vertragsstrafe = Abrechnungsverhältnis x verbleibende Tage x Investitionsbetrag.",
    理财规则7:"Beispiel: Die pauschalierte Schadensersatzquote dieses Produkts beträgt",
    剩余:"Übrig",
    天到期投资:"Es läuft in Tagen ab und der Investitionsbetrag beträgt",
    则:"Aber",
    违约金:"pauschalierter Schadensersatz",
    实际退还本金为:"Der tatsächlich zurückgegebene Kapitalbetrag ist",
    现货账户:"Spot-Konto",
    总资产:"Gesamtassets",
    充币:"Einzahlung",
    提币:"Auszahlung",
    闪兑:"Swap",
    投资组合:"Portfolio",
    冻结数量:"Blockierte",
    帮助中心:"Hilfezentrum",
    自选:"Favoriten",
    行情:"Markt",
    资金:"Kapital",
    资讯:"Information",
    我的:"Mein",
    交易对:"Handelspaare",
    最新价:"Letzter Kurs",
    成交量:"Volumen",
    标记价格:"Markpreis",
    h24最高价:"24h Höchstpreis",
    h24最低价:"24h niedrigster Preis",
    h24成交量:"24-Stunden-Handelsvolumen",
    h24交易额:"24h Vol",
    分时:"Zeit teilen",
    分1:"1 Punkt",
    分5:"5 Punkte",
    分15:"15 Mark",
    分30:"30 Punkte",
    小时1:"1 Stunde",
    天1:"1 Tag",
    周1:"1 Woche",
    月1:"Januar",
    委托订单:"Befehl",
    最新交易:"Neueste Transaktionen",
    买入:"Kaufen",
    卖出:"verkaufen",
    时间:"Zeit",
    方向:"Richtung",
    取消自选成功:"Auswahl erfolgreich abbrechen",
    添加成功:"Erfolgreich hinzugefügt",
    登录:"Anmeldung",
    账户:"Konto",
    邮箱:"Post",
    手机号:"Telefonnummer",
    请输入账户:"Bitte Konto eingeben",
    请输入邮箱:"Bitte geben Sie Ihre E-Mail-Adresse ein",
    请输入手机号:"Bitte geben Sie die Telefonnummer ein",
    密码:"Passwort",
    请输入密码:"Bitte Passwort eingeben",
    忘记密码:"Passwort vergessen?",
    还没有账号:"Noch keinen Account",
    去注册:"Gehen Sie zur Registrierung",
    请输入登录账号:"Bitte geben Sie Ihr Login-Konto ein",
    请输入登录密码:"Bitte geben Sie Ihr Passwort ein",
    登录失败:"Fehler bei der Anmeldung",
    历史记录:"Geschichtsaufzeichnung",
    充值:"nachfüllen",
    提现:"zurückziehen",
    未审核:"Nicht überprüft",
    成功:"Erfolg",
    失败:"scheitern",
    快捷入口:"Schnellzugriff",
    资金密码:"Passwort für den Fonds",
    登录密码:"Passwort",
    账变记录:"Kontobewegungen",
    邀请推广:"Einladung",
    通用:"Allgemein",
    语言:"Sprache",
    在线客服:"Online-Support",
    身份认证:"Authentifizierung",
    高级认证:"Erweiterte KYC-Prüfung",
    更多:"Mehr",
    帮助中心:"Hilfezentrum",
    关于我们:"Über uns",
    退出:"Abmelden",
    已提交身份认证:"Sie haben Ihre Identitätsinformationen übermittelt und diese werden derzeit überprüft",
    您已完成身份认证:"Sie haben die Identitätsprüfung abgeschlossen",
    您已完成高级认证:"Sie haben die Advanced-Zertifizierung abgeschlossen",
    确定退出登录:"Möchten Sie sich wirklich abmelden?",
    资讯:"Information",
    公告:"Bekanntmachung",
    状态:"Zustand",
    已成交:"Geschäft abgeschlossen",
    委托金额:"Provisionsbetrag",
    剩余金额:"Gleichgewicht",
    订单类型:"Auftragsart",
    市价委托:"Marktordnung",
    限价委托:"Limit-Order",
    订单号:"Bestellnummer",
    委托时间:"Provisionszeit",
    U本位合约历史:"USDT-M Futures Orders",
    成交数量:"Die Anzahl der Transaktionen",
    实现盈亏:"Gewinn und Verlust realisieren",
    推广记录:"Beförderungsrekord",
    我的总推广:"Meine allgemeine Beförderung",
    总充值:"Vollständige Aufladung",
    一代人数:"Anzahl der Generationen",
    二代人数:"Anzahl der zweiten Generation",
    三代人数:"Anzahl von drei Generationen",
    立即推广:"Jetzt bewerben",
    我的推广:"meine Beförderung",
    用户名:"Nutzername",
    加密货币:"Krypto",
    外汇:"FX",
    股票:"Aktien",
    现货交易:"Spot",
    热门:"Hot",
    涨幅榜:"Top Gainer",
    跌幅榜:"Top Loser",
    快速充币:"Schnelle Einzahlung",
    保存二维码:"QR-Code speichern",
    复制地址:"Adresse kopieren",
    转出地址:"Absenderadresse (optional)",
    请输入转出地址:"Bitte geben Sie die Absenderadresse ein",
    粘贴:"Paste",
    充币数量:"Einzahlungsbetrag",
    请输入充币数量:"Bitte geben Sie den Einzahlungsbetrag ein",
    区块链网络:"Blockchain-Netzwerk",
    付款凭证:"Zahlungsbeleg (Screenshot der Zahlungsdetails hochladen)",
    请输入充值数量:"Bitte geben Sie den Aufladebetrag ein",
    充值通道:"Aufladekanal",
    请选择充值币种:"Bitte wählen Sie die Aufladewährung aus",
    官方充值通道:"Offizieller Aufladekanal",
    设置密码:"Passwort festlegen",
    确认密码:"Bestätige das Passwort",
    验证码:"Bestätigungscode",
    请输入验证码:"Bitte geben Sie den Bestätigungscode ein",
    获取验证码:"Holen Sie sich den Bestätigungscode",
    重新发送:"Erneut senden",
    邀请码:"Einladungscode",
    请输入邀请码:"Bitte geben Sie den Einladungscode ein",
    我已阅读并同意:"Ich habe gelesen und stimme zu",
    服务条款:"Nutzungsbedingungen",
    注册:"registrieren",
    已有账号:"Sie haben bereits ein Konto",
    去登录:"Gehen Sie zum Anmelden",
    请再次输入密码:"Bitte geben Sie das Passwort erneut ein",
    请同意服务条款:"Bitte stimmen Sie den Nutzungsbedingungen zu",
    注册失败:"Registrierung fehlgeschlagen",
    欢迎来到:"Willkommen zu",
    全球最大的区块链资产平台:"Die weltweit größte Blockchain-Asset-Plattform",
    分享二维码:"Teilen Sie den QR-Code",
    链接分享:"Linkfreigabe",
    复制:"Kopieren",
    您的邀请码:"Ihren Einladungscode",
    到数字币地址:"Zur digitalen Währungsadresse",
    选择币种:"Währung wählen",
    区块链网络:"Blockchain-Netzwerk",
    提币说明:"Widerrufsbelehrung",
    提现费用:"Abhebegebühren",
    可到账数量:"Verfügbare Anzahl",
    可用:"Verfügbar",
    请输入支付密码:"Bitte geben Sie das Zahlungspasswort ein",
    请输入提币数量:"Bitte geben Sie den Auszahlungsbetrag ein",
    全部:"alle",
    支付密码:"Zahlungspasswort",
    地址:"Adresse",
    委托价:"Bestellpreis",
    成交时间:"Transaktionszeit",
    成交金额:"Umsatz",
    委托中:"Auf Provision",
    持仓中:"In Position",
    平仓中:"Positionsschließung",
    已平仓:"Position geschlossen",
    开仓倍数:"Mehrere öffnen",
    委托价格:"Provisionspreis",
    收盘价:"Schlusskurs",
    收益率:"Rendite",
    平仓时间:"Geschäftsschluss",
    请输入转换数量:"Bitte geben Sie die Umrechnungsmenge ein",
    请上传付款凭证:"Bitte laden Sie den Zahlungsbeleg hoch",
    开盘价:"Eröffnungskurs",
    开市中:"Offen",
    已休市:"Der Markt wurde geschlossen",
    美股:"Aktien",
    平仓价:"Schlusskurs",
    到期结算完成:"Fälligkeitsabwicklung abgeschlossen",
    印度股票:"Indische Aktien",
    马来股票:"Malaiische Aktien",
    结算中:"Sich niederlassen",
    越南股票:"Vietnam-Aktien",
    设置资金密码:"Legen Sie ein Fondspasswort fest",
    请输入资金密码:"Bitte geben Sie das Fondspasswort ein",
    取消:"Stornieren",
    确定:"Sicher",
    止损价:"Stop-Loss-Preis",
    请输入止损价格:"Bitte geben Sie den Stop-Loss-Preis ein",
    请输入止盈价格:"Bitte geben Sie den Take-Profit-Preis ein",
    止盈价:"Nehmen Sie den Gewinnpreis",
    设置止盈止损:"Legen Sie Take-Profit und Stop-Loss fest",
    请输入关键词:"Bitte geben Sie ein Schlüsselwort ein",
    搜索结果:"Suchergebnisse",
    添加收款方式:"Zahlungsmethode hinzufügen",
    高级认证:"Erweiterte Zertifizierung",
    历史委托:"Historische Kommission",
    选择区域码:"Vorwahl auswählen",
    请上传身份证图片:"Bitte laden Sie ein Bild Ihres Personalausweises hoch",
    请上传护照照片:"Bitte laden Sie ein Passfoto hoch",
    请输入提币地址:"Bitte geben Sie die Auszahlungsadresse ein",
    设置语言:"Spracheinstellungen",
    最低金额: "Mindestbetrag",
    购买金额: "Kaufpreis",
    请输入要搜索的国家名称: "Bitte geben Sie den Namen des Landes ein, nach dem Sie suchen möchten",
    确定执行该操作: "Bestätigen Sie dies?",
    历史搜索: "Historische Recherchen",
    现货持仓: "Spot",
    永续持仓: "Futures",
    到期结算中: "Setzung bei Fälligkeit",
    火花图: "Spark Chart",
    计价单位: "Währungseinheit",
    您拒绝了链接: "Sie haben den Link abgelehnt",
    连接钱包成功: "Wallet-Verbindung erfolgreich",
    已断开钱包: "Verbindung zur Brieftasche getrennt",
    钱包切换成功: "Wallet-Wechsel erfolgreich",
    请先安装钱包插件: "Bitte installieren Sie zuerst das Wallet-Plugin",
    连接钱包: "Wallet verbinden",
    交易: "Handel",
    确认报价: "Angebot bestätigen",
    您将获得: "Sie erhalten",
    兑换自: "Tausch aus",
    汇率: "Tauschrate",
    返回: "zurückkehren",
    兑换: "Umtauschen",

    消息: "Information",
    身份证反面照片: "Foto der Rückseite des Personalausweises",
    身份证正面照片: "Foto auf der Vorderseite des Personalausweises",
    手持身份证照片: "Foto des Personalausweises in der Hand",
    划转: "überweisen",
    请输入划转数量: "Bitte geben Sie den Überweisungsbetrag ein(USDT)",
    消息: "Information",
    身份证反面照片: "Foto der Rückseite des Personalausweises",
    身份证正面照片: "Foto auf der Vorderseite des Personalausweises",
    手持身份证照片: "Foto des Personalausweises in der Hand",
    划转: "überweisen",
    请输入划转数量: "Bitte geben Sie den Überweisungsbetrag ein(USDT)",
    邀请链接: "Einladungslink",
    资料总览: "Datenübersicht",
    推广规则: "Werberegeln",
    总邀请人数: "Gesamtzahl der eingeladenen Personen",
    总佣金: "Gesamtprovision",
    安全绑定: "sichere Bindung",
    规则1: "1.Diese Adresse akzeptiert nur {type}. Bitte überweisen Sie keine anderen Assets als {type} auf diese Adresse, da diese sonst nicht wiederhergestellt werden können.",
    规则2: "2.Nachdem Sie die obige Adresse aufgeladen haben, müssen Sie auf die Bestätigung der Netzwerkknoten warten. Sobald die Netzwerkknoten die Transaktion bestätigt haben, wird das Asset automatisch Ihrem Konto gutgeschrieben. Wir werden Sie über den Eingang Ihres Assets in Form einer Website-Ankündigung informieren.",
    规则3: "3.Ihre Einzahlungsadresse ändert sich nicht häufig und kann für wiederholte Einzahlungen verwendet werden. Sollte es zu einer Änderung kommen, informieren wir Sie über eine Ankündigung auf der Website.",

    安全绑定: "sichere Bindung",
    安全中心: "Sicherheitscenter",
    绑定手机号: "Mobiltelefonnummer binden",
    认证中心: "Zertifizierungszentrum",
    身份认证: "Authentifizierung",
    认证要求: "Zertifizierungsanforderungen",
    政府发行的证件: "Von der Regierung ausgestellte Dokumente",
    功能与限制: "Funktionen und Einschränkungen",
    无限额: "Keine Begrenzung",
    预计审核时间: "Geschätzte Durchsichtszeit: 60 Minuten",
    开始认证: "Zertifizierung starten",
    充币规则: "Einzahlungsregeln",
    加密货币股票多类选择: "Mehrfachauswahl von Kryptowährungsaktien",
    个人中心: "Persönliches Zentrum",
    充值记录: "Aufladeaufzeichnung",
    提现记录: "Abhebungsprotokoll"
    

    

    
}


// WEBPACK FOOTER //
// ./src/lang/de.js